/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .media-center-photo[_ngcontent-%COMP%]{position:relative;height:146px;width:em(300);border-radius:6px}[_nghost-%COMP%]   .media-center-photo-img[_ngcontent-%COMP%]{-o-object-fit:cover;object-fit:cover;width:100%;height:100%;border-radius:inherit}"];
export { styles as styles };
